import React from 'react'
import { IoClose, IoTrashOutline, IoArrowBack } from 'react-icons/io5'
import { useTimer } from '../../../hooks/useTimer'
import {
  ModalOverlay,
  ModalContainer,
  CloseButton,
  ModalTitle,
  ModalSubtitle,
  ButtonsContainer,
  ActionButton,
} from './styles'

interface ICloseTimerModalProps {
  isOpen: boolean
  onClose: () => void
}

/**
 * Modal exibido ao tentar fechar o cronômetro
 * Confirma se o usuário deseja encerrar e zerar o timer
 */
const CloseTimerModal: React.FC<ICloseTimerModalProps> = ({ isOpen, onClose }) => {
  const { resetTimer, setVisibility } = useTimer()

  if (!isOpen) return null

  // Handler para confirmar encerramento
  const handleConfirmClose = () => {
    resetTimer()
    setVisibility(false)
    onClose()
  }

  // Handler para cancelar
  const handleCancel = () => {
    onClose()
  }

  // Handler para ESC key
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      handleCancel()
    }
  }

  return (
    <ModalOverlay onClick={handleCancel} onKeyDown={handleKeyDown}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={handleCancel} aria-label="Fechar">
          <IoClose />
        </CloseButton>

        <ModalTitle>Deseja encerrar o cronômetro?</ModalTitle>

        <ModalSubtitle>
          O tempo será zerado e você poderá iniciar novamente quando quiser.
        </ModalSubtitle>

        <ButtonsContainer>
          <ActionButton variant="secondary" onClick={handleCancel}>
            <IoArrowBack />
            Continuar
          </ActionButton>

          <ActionButton variant="danger" onClick={handleConfirmClose}>
            <IoTrashOutline />
            Encerrar cronômetro
          </ActionButton>
        </ButtonsContainer>
      </ModalContainer>
    </ModalOverlay>
  )
}

export default CloseTimerModal
